'use client';

import * as React from 'react';
import { FileDetailsModalContent } from '@/app/dashboard/cms/file-storage/components/file-details-modal-content';
import { useAppSelector } from '@/store/hooks';
import { getUi } from '@/store/reducers/ui-slice';

import { ModalDrawer } from '@/types/general';

import { ModalLayout } from '../core/modal-layout';

export function FileDetailsModal(): React.JSX.Element {
  const { modal } = useAppSelector(getUi);

  return (
    <ModalLayout title="Media Item" isOpen={modal?.open === ModalDrawer.MEDIA_ITEM_VIEW}>
      <FileDetailsModalContent />
    </ModalLayout>
  );
}
